import { jsx } from "react/jsx-runtime";
import { Box } from "../Box/Box.mjs";
import { ButtonIcon } from "../ButtonIcon/ButtonIcon.mjs";
import { MenuRenderer } from "../MenuRenderer/MenuRenderer.mjs";
import { wrapperPositioning } from "./OverflowMenu.css.mjs";
import { IconOverflow } from "../icons/IconOverflow/IconOverflow.mjs";
const OverflowMenu = ({
  size,
  label,
  children,
  id,
  ...menuProps
}) => /* @__PURE__ */ jsx(
  Box,
  {
    className: wrapperPositioning,
    display: "flex",
    justifyContent: "flexEnd",
    children: /* @__PURE__ */ jsx(
      MenuRenderer,
      {
        trigger: (triggerProps) => /* @__PURE__ */ jsx(
          ButtonIcon,
          {
            id,
            size,
            icon: /* @__PURE__ */ jsx(IconOverflow, {}),
            variant: "transparent",
            label,
            ...triggerProps
          }
        ),
        align: "right",
        size,
        offsetSpace: size === "standard" ? "small" : "xsmall",
        ...menuProps,
        children
      }
    )
  }
);
export {
  OverflowMenu
};
